/** @flow */
import styled from 'styled-components';

const Layout = styled.div`
  margin: 0px;
  background-color: ${({ theme }) => theme.colors.primaryBackground};
  min-height: 100vh;
  height: 100%;
`;

const Logo = styled.img`
  height: 54px;
  margin-top: 5px;
`;

const ResponsiveColumn = styled.div`
  width: 100%;
  height: 250px;

  @media (min-width: 1200px) {
    height: ${({ height }) => (height || '50%')};
    padding-top: ${({ bottom }) => (bottom ? '.5rem' : 0)};
    padding-bottom: ${({ bottom }) => (bottom ? 0 : '.5rem')};
  }
`;

export {
  Layout,
  Logo,
  ResponsiveColumn,
};



// WEBPACK FOOTER //
// ./src/common/layout/styles/index.js